// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8601) return "static/chunks/solana-79ea18aafde224fc.js";
	if (chunkId === 1862) return "static/chunks/mapbox-db49856f8050f964.js";
	if (chunkId === 1624) return "static/chunks/1624-94c769fd19828e49.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"577":"0689ffc79d08f015","6687":"33f763c65a830af0","9573":"fae60fb2b85ed7e0"}[chunkId] + ".js";
};